var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { autoinject, transient, bindable } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { InstantGameTypes } from "../../../../../models/modules/lotteryplatofrm.models";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { resolveBrandCapabilities } from "../../../../../models/modules/render-brand-capabilities";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { BrandClientService } from "../../../../../services/modules/brand-client.service";
import { AttachmentClientService } from "../../../../../services/modules/attachements-client.service";
import { RenderThemeClientService } from "../../../../../services/modules/render-theme-client.service";
import { RenderPageType, RenderSectionType } from "../../../../../models/modules/render-theme.models";
import { RenderVariantCatalog, findRenderVariant, variantPages, variantVersion, variantDevices, AllRenderDevices } from "../../../../../models/modules/render-variant-catalog";
import { InstantGameKeyHelper, TemplateType } from "../../../../../services/modules/brand-client.service";
import { Guid } from "../../../../../utilities/guid";
var BrandRenderLayout = /** @class */ (function (_super) {
    __extends(BrandRenderLayout, _super);
    function BrandRenderLayout(notificationService, i18N, brandClientService, attachmentClientService, renderThemeClientService) {
        var _a;
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.brandClientService = brandClientService;
        _this.attachmentClientService = attachmentClientService;
        _this.renderThemeClientService = renderThemeClientService;
        _this.theme = null;
        _this.layout = null;
        _this.templateName = null;
        _this.selectedPageType = RenderPageType.Lobby;
        _this.selectedPage = "lobby";
        _this.loading = false;
        _this.saving = false;
        _this.publishing = false;
        // When false the host (combined editor) supplies a shared preview and selection sink instead
        // of the per-step embedded preview; standalone wizard usage keeps the embedded preview.
        _this.embeddedPreview = true;
        // Item-scoped editor mode (set by the bundle/syndicate render dialog before activation): edits one
        // bundle's Bundle-page (or one syndicate's Syndicate-page) override instead of a brand's pages. The
        // brand/template come via overrides because the dialog's model is a BundleModel/SyndicateModel.
        _this.bundleId = null;
        _this.syndicateId = null;
        _this.brandLotteryId = null;
        _this.overrideBrandId = null;
        _this.overrideTemplateName = null;
        _this.selectedInstanceId = null;
        _this.onSelect = null;
        // Host hook: fired when the placed-section set changes (add/remove) so the Style panel can refresh
        // its colour groups without a browser reload.
        _this.onLayoutChanged = null;
        _this.newVariantId = null;
        _this.newChildVariantId = {};
        // Per-item data capabilities (e.g. { subscription: false, syndicate: true }) supplied by the lottery
        // editor. A variant requiring a capability that is KNOWN to be false is hidden from "Add Section". Null
        // (brand/bundle/syndicate editors) or an unknown capability leaves the section offered.
        _this.requiredCapabilities = null;
        // Supplied by the host editor. A section that renders one image per item (instant games) edits those
        // from its own modal, but they are stored as the brand theme's per-language image tokens - the same
        // place the runtime reads them from - so the Structure pane needs a live handle on that dictionary
        // and on the theme's save. Absent (e.g. the item dialogs) -> the per-item upload slots stay hidden.
        _this.itemImageHost = null;
        // The brand's subscribed instant games (name + slug), resolved once per load.
        _this.brandInstantGames = [];
        // Slot objects are cached per section: the view binds them directly, so they must be stable across
        // dirty-checks (a fresh array each check would thrash the bindings).
        _this.itemImageSlotCache = {};
        _this.lotteryLinkOptions = [];
        _this.hiddenBefore = [];
        _this.hiddenAfter = [];
        // The section being edited in the modal (null = closed).
        _this.editingSection = null;
        _this.buildVariantOptions();
        // Advert image/link is edited via the dedicated image-props UI (usesImageProps), not here.
        _this.propSchemas = (_a = {},
            _a[RenderSectionType.LotteriesGrid] = [
                { key: "showQuickPlay", label: _this.i18N.tr("render-prop-showQuickPlay"), type: "bool" }
            ],
            _a);
        return _this;
    }
    BrandRenderLayout_1 = BrandRenderLayout;
    BrandRenderLayout.prototype.onActivated = function (model) {
        this.theme = null;
        this.layout = null;
        if (this.bundleId != null) {
            this.selectedPageType = RenderPageType.Bundle;
            this.loadForItem(this.bundleId, null, null);
        }
        else if (this.syndicateId != null) {
            this.selectedPageType = RenderPageType.Syndicate;
            this.loadForItem(null, this.syndicateId, null);
        }
        else if (this.brandLotteryId != null) {
            this.selectedPageType = RenderPageType.Lottery;
            this.loadForItem(null, null, this.brandLotteryId);
        }
        else if (model && model.brandId) {
            this.load(model);
        }
    };
    BrandRenderLayout.prototype.loadForItem = function (bundleId, syndicateId, brandLotteryId) {
        var _this = this;
        this.loading = true;
        this.templateName = this.overrideTemplateName;
        this.renderThemeClientService.getTheme(this.overrideBrandId, this.templateName, bundleId, syndicateId, brandLotteryId).then(function (theme) {
            _this.bindTheme(theme);
            _this.loading = false;
        }).catch(function () {
            _this.loading = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-theme-load-error"), NotificationType.Error);
        });
    };
    BrandRenderLayout.prototype.resolveBrandId = function () {
        if (this.bundleId != null || this.syndicateId != null || this.brandLotteryId != null)
            return this.overrideBrandId;
        return this.item ? this.item.brandId : null;
    };
    BrandRenderLayout.prototype.load = function (brand) {
        var _this = this;
        this.loading = true;
        this.buildLotteryLinkOptions(brand);
        this.requiredCapabilities = resolveBrandCapabilities(brand);
        this.buildBrandInstantGames(brand);
        this.brandClientService.getTemplates().then(function (templates) {
            var template = Enumerable.from(templates).firstOrDefault(function (t) { return t.templateId == brand.templateId; });
            _this.templateName = template ? template.internalName : null;
            _this.renderThemeClientService.getTheme(brand.brandId, _this.templateName).then(function (theme) {
                _this.bindTheme(theme);
                _this.loading = false;
            }).catch(function () {
                _this.loading = false;
                _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-theme-load-error"), NotificationType.Error);
            });
        });
    };
    BrandRenderLayout.prototype.buildLotteryLinkOptions = function (brand) {
        this.lotteryLinkOptions = Enumerable.from(brand.activeBrandLotteries || [])
            .where(function (bl) { return bl.isSubscribed && !!bl.lottery && bl.lotteryId != null; })
            .select(function (bl) { return ({ value: "lottery/".concat(bl.lotteryId), name: bl.lottery.name }); })
            .toArray();
    };
    BrandRenderLayout.prototype.bindTheme = function (theme) {
        this.theme = theme;
        if (!theme) {
            this.layout = null;
            return;
        }
        theme.layouts = theme.layouts || [];
        this.selectLayoutPage(this.selectedPageType);
    };
    // A section is hidden from "Add Section" only when the edited item is KNOWN not to support it
    // (capability explicitly false); unknown/true keeps it offered.
    BrandRenderLayout.prototype.capabilityMissing = function (v) {
        return !!this.requiredCapabilities && !!v && !!v.requiresCapability
            && this.requiredCapabilities[v.requiresCapability] === false;
    };
    // A placed section is unsupported when the edited item is KNOWN not to support its variant's
    // capability (e.g. a Subscription Banner on a non-subscription lottery). The seed places these
    // in every lottery; they are greyed/flagged in the Structure pane and stripped on save (they
    // already self-hide at runtime).
    BrandRenderLayout.prototype.sectionUnsupported = function (section) {
        return this.capabilityMissing(this.effectiveVariant(section));
    };
    BrandRenderLayout.prototype.stripUnsupported = function (sections) {
        var _this = this;
        return (sections || [])
            .filter(function (s) { return !_this.sectionUnsupported(s); })
            .map(function (s) { return s.children ? __assign(__assign({}, s), { children: _this.stripUnsupported(s.children) }) : s; });
    };
    BrandRenderLayout.prototype.buildVariantOptions = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        // Unsupported variants stay in the list but are greyed/non-selectable (disabled), so admins can
        // see what exists for the page without picking something the edited item can't render.
        var owned = this.itemOwnedTypes();
        var variants = Enumerable.from(RenderVariantCatalog)
            .where(function (v) { return variantPages(v).indexOf(_this.selectedPageType) >= 0; })
            .where(function (v) { return !owned || owned.indexOf(v.type) >= 0; })
            .orderBy(function (v) { return v.type; })
            .thenBy(function (v) { return variantVersion(v); })
            .toArray();
        this.childVariantOptions = variants.map(function (v) { return ({ id: v.id, name: _this.variantOptionName(v), disabled: _this.capabilityMissing(v) }); });
        // Add-Section list: Row first (no device restriction), then catalog variants grouped by the
        // devices they render on, each group preceded by a non-selectable header. Headers only appear
        // when there's more than one group (so a single-group page stays a plain flat list).
        var groups = [];
        var groupFor = function (devices) {
            var key = _this.deviceGroupKey(devices);
            var g = groups.filter(function (x) { return x.key === key; })[0];
            if (!g) {
                g = { key: key, label: _this.deviceGroupLabel(devices), items: [] };
                groups.push(g);
            }
            return g;
        };
        groupFor(AllRenderDevices).items.push({ id: BrandRenderLayout_1.RowOptionId, name: this.sectionLabel(RenderSectionType.Row) });
        try {
            for (var variants_1 = __values(variants), variants_1_1 = variants_1.next(); !variants_1_1.done; variants_1_1 = variants_1.next()) {
                var v = variants_1_1.value;
                groupFor(variantDevices(v)).items.push({ id: v.id, name: this.variantOptionName(v), disabled: this.capabilityMissing(v) });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (variants_1_1 && !variants_1_1.done && (_a = variants_1.return)) _a.call(variants_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        groups.sort(function (a, b) { return (a.key === "all" ? -1 : b.key === "all" ? 1 : 0); }); // keep "all" first
        if (groups.length <= 1) {
            this.variantOptions = groups.length ? groups[0].items : [];
            return;
        }
        var options = [];
        try {
            for (var groups_1 = __values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                var g = groups_1_1.value;
                options.push({ id: "__header_" + g.key, name: g.label, isGroupHeader: true });
                g.items.forEach(function (it) { return options.push(it); });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (groups_1_1 && !groups_1_1.done && (_b = groups_1.return)) _b.call(groups_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.variantOptions = options;
    };
    // Host hook: the lottery editor resolves the item's capabilities asynchronously, after the options are
    // first built - re-filter "Add Section" once they arrive.
    BrandRenderLayout.prototype.applyCapabilities = function (capabilities) {
        this.requiredCapabilities = capabilities;
        this.buildVariantOptions();
    };
    BrandRenderLayout.prototype.variantOptionName = function (v) {
        return "".concat(this.sectionLabel(v.type), " - V").concat(variantVersion(v));
    };
    BrandRenderLayout.prototype.deviceGroupKey = function (devices) {
        return devices.length === AllRenderDevices.length ? "all" : devices.slice().sort().join("-");
    };
    BrandRenderLayout.prototype.deviceGroupLabel = function (devices) {
        var _this = this;
        if (devices.length === AllRenderDevices.length)
            return this.i18N.tr("render-device-all");
        var names = devices.map(function (d) { return _this.i18N.tr("render-device-" + d); });
        // escapeValue:false - i18next HTML-escapes interpolated values by default ("&" → "&amp;").
        return this.i18N.tr("render-device-only", { devices: names.join(" & "), interpolation: { escapeValue: false } });
    };
    BrandRenderLayout.prototype.selectLayoutPage = function (pageType) {
        var _this = this;
        this.selectedPageType = pageType;
        this.selectedPage = BrandRenderLayout_1.PageNameByType[pageType] || "lobby";
        this.buildVariantOptions();
        if (!this.theme) {
            this.layout = null;
            return;
        }
        this.theme.layouts = this.theme.layouts || [];
        var doc = Enumerable.from(this.theme.layouts).firstOrDefault(function (l) { return l.pageType == pageType; });
        if (!doc) {
            doc = { renderLayoutDocumentId: 0, pageType: pageType, name: null, sections: [] };
            this.theme.layouts.push(doc);
        }
        doc.sections = doc.sections || [];
        doc.sections.forEach(function (s) { return _this.ensureSectionShape(s); });
        this.layout = this.applyItemScope(doc);
    };
    // An item editor (currently the syndicate dialog) only edits the item-owned sections; the shared
    // page sections (lotteries carousel, banner, adverts) are hidden from the Structure + Style panes to
    // avoid the impression they belong to the item. They are NOT dropped - held aside here and merged
    // back on save so they keep rendering. The owned sections form a contiguous block in the seed, so
    // the hidden ones anchor before/after that block.
    BrandRenderLayout.prototype.itemOwnedTypes = function () {
        if (this.syndicateId != null)
            return [RenderSectionType.SyndicateDetails];
        return null;
    };
    BrandRenderLayout.prototype.applyItemScope = function (doc) {
        var _this = this;
        this.hiddenBefore = [];
        this.hiddenAfter = [];
        var owned = this.itemOwnedTypes();
        if (!owned)
            return doc;
        var firstOwned = doc.sections.findIndex(function (s) { return owned.indexOf(s.type) >= 0; });
        if (firstOwned < 0)
            return doc;
        var visible = [];
        doc.sections.forEach(function (s, i) {
            if (owned.indexOf(s.type) >= 0)
                visible.push(s);
            else if (i < firstOwned)
                _this.hiddenBefore.push(s);
            else
                _this.hiddenAfter.push(s);
        });
        return __assign(__assign({}, doc), { sections: visible });
    };
    BrandRenderLayout.prototype.mergeItemScope = function (sections) {
        if (!this.itemOwnedTypes())
            return sections;
        return __spreadArray(__spreadArray(__spreadArray([], __read(this.hiddenBefore), false), __read(sections), false), __read(this.hiddenAfter), false);
    };
    BrandRenderLayout.prototype.onPreviewPageChanged = function (page) {
        var type = BrandRenderLayout_1.PageTypeByName[page];
        if (type != null)
            this.selectLayoutPage(type);
    };
    Object.defineProperty(BrandRenderLayout.prototype, "pageLabel", {
        get: function () {
            return this.i18N.tr("render-page-" + (this.selectedPage || "lobby"));
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderLayout.prototype.ensureSectionShape = function (section) {
        var _this = this;
        section.props = section.props || {};
        if (!section.instanceId)
            section.instanceId = Guid.generateGuid();
        if (this.usesImageProps(section) || this.usesBackgroundImage(section))
            section.props.image = section.props.image || {};
        (section.children || []).forEach(function (c) { return _this.ensureSectionShape(c); });
    };
    BrandRenderLayout.prototype.effectiveVariant = function (section) {
        if (section && section.variant)
            return findRenderVariant(section.variant);
        return section ? (RenderVariantCatalog.filter(function (v) { return v.isDefault && v.type === section.type; })[0] || null) : null;
    };
    BrandRenderLayout.prototype.usesImageProps = function (section) {
        var variant = this.effectiveVariant(section);
        return !!(variant && variant.imageProps);
    };
    BrandRenderLayout.prototype.usesBackgroundImage = function (section) {
        var variant = this.effectiveVariant(section);
        return !!(variant && variant.backgroundImage);
    };
    // The games the brand actually sells. The collection carries a row per AVAILABLE game, so it must be
    // filtered by `isSubscribed` (the same filter the brand's Instant Games tab applies).
    BrandRenderLayout.prototype.buildBrandInstantGames = function (brand) {
        var games = (brand && (brand.activeBrandInstantGames || brand.brandInstantGames)) || [];
        var seen = {};
        this.brandInstantGames = games
            .filter(function (g) { return g.isSubscribed && g.instantGame && g.instantGame.name; })
            .map(function (g) { return ({
            name: g.instantGame.name,
            slug: InstantGameKeyHelper.getKey(g.instantGame.name),
            typeId: g.instantGame.instantGameTypeId
        }); })
            .filter(function (g) { return (seen[g.slug] ? false : (seen[g.slug] = true)); });
        this.itemImageSlotCache = {};
    };
    // True for any section that carries per-item images, even when it currently lists none - the modal
    // then explains why it is empty instead of the kebab silently disappearing.
    BrandRenderLayout.prototype.usesItemImages = function (section) {
        var variant = this.effectiveVariant(section);
        return !!(section && variant && variant.itemImages === "instantGame" && this.itemImageHost);
    };
    // The visible keys of one lobby config list (e.g. "instant-game-cards"), as the runtime reads them.
    // The lists live in the theme's token set under `configs`, mirroring the old lobby.json.
    BrandRenderLayout.prototype.lobbyConfigKeys = function (brandingType) {
        var lobby = this.theme && this.theme.tokens && this.theme.tokens.configs
            ? this.theme.tokens.configs[TemplateType.Lobby]
            : null;
        var list = lobby && lobby[TemplateType.Lobby] ? lobby[TemplateType.Lobby][brandingType] : null;
        if (!list || !list.length)
            return [];
        return list.filter(function (x) { return x.isVisible !== false; }).map(function (x) { return x.key; });
    };
    // The games a given section actually renders, mirroring base-lobby: Instant Games shows the
    // InstantGame-typed ones, while the cards grid and the scratch-card carousel both draw from the
    // Scratchcard-typed ones narrowed by their own lobby config list.
    BrandRenderLayout.prototype.instantGamesForSection = function (section) {
        if (section.type === RenderSectionType.InstantGames)
            return this.brandInstantGames.filter(function (g) { return g.typeId === InstantGameTypes.InstantGame; });
        var scratchcards = this.brandInstantGames.filter(function (g) { return g.typeId === InstantGameTypes.Scratchcard; });
        var brandingType = section.type === RenderSectionType.InstantGameCards
            ? "instant-game-cards"
            : "carousel-scratchcards";
        var keys = this.lobbyConfigKeys(brandingType);
        if (!keys.length)
            return [];
        return scratchcards.filter(function (g) { return keys.indexOf(g.slug) >= 0; });
    };
    // Upload slots for a section that renders one image per item. Cached per section instance so the
    // bindings stay stable; empty when the host supplies no token dictionary or the brand has no items.
    BrandRenderLayout.prototype.itemImageSlots = function (section) {
        var variant = this.effectiveVariant(section);
        if (!section || !variant || variant.itemImages !== "instantGame" || !this.itemImageHost)
            return [];
        var cached = this.itemImageSlotCache[section.instanceId];
        if (cached)
            return cached;
        var host = this.itemImageHost;
        var slots = this.instantGamesForSection(section).map(function (game) {
            var key = game.slug + "-lobby-instant-game-background";
            return {
                key: key,
                label: game.name,
                get value() {
                    var dict = host.imageDict();
                    return dict ? dict[key] : null;
                },
                set value(uri) {
                    var dict = host.imageDict();
                    if (!dict)
                        return;
                    // An empty slot must not be stored: a blank image token overrides the real image with
                    // nothing at runtime, so clearing a slot removes the key instead.
                    if (uri)
                        dict[key] = uri;
                    else
                        delete dict[key];
                }
            };
        });
        this.itemImageSlotCache[section.instanceId] = slots;
        return slots;
    };
    Object.defineProperty(BrandRenderLayout.prototype, "itemImagesLabel", {
        get: function () {
            return this.i18N.tr("render-prop-instant-game-images");
        },
        enumerable: false,
        configurable: true
    });
    // These images are theme tokens, not layout props, so they save through the theme pane rather than
    // with "Save Layout" - the modal offers its own button so the upload can be committed in place.
    BrandRenderLayout.prototype.saveItemImages = function () {
        if (this.itemImageHost)
            this.itemImageHost.save();
    };
    Object.defineProperty(BrandRenderLayout.prototype, "isPreset", {
        get: function () {
            return this.theme != null && !this.theme.brandId;
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderLayout.prototype.sectionLabel = function (type) {
        var name = RenderSectionType[type];
        var label = this.i18N.tr("render-section-" + name);
        return label && label !== "render-section-" + name ? label : name;
    };
    BrandRenderLayout.prototype.variantLabel = function (section) {
        var variant = this.effectiveVariant(section);
        return variant ? "".concat(this.sectionLabel(variant.type), " - V").concat(variantVersion(variant)) : this.sectionLabel(section.type);
    };
    BrandRenderLayout.prototype.propSchema = function (type) {
        return this.propSchemas[type] || [];
    };
    BrandRenderLayout.prototype.moveUp = function (index) {
        if (index <= 0)
            return;
        var _a = __read(this.layout.sections.splice(index, 1), 1), section = _a[0];
        this.layout.sections.splice(index - 1, 0, section);
    };
    BrandRenderLayout.prototype.moveDown = function (index) {
        if (index >= this.layout.sections.length - 1)
            return;
        var _a = __read(this.layout.sections.splice(index, 1), 1), section = _a[0];
        this.layout.sections.splice(index + 1, 0, section);
    };
    BrandRenderLayout.prototype.removeSection = function (index) {
        this.layout.sections.splice(index, 1);
        this.notifyLayoutChanged();
    };
    BrandRenderLayout.prototype.notifyLayoutChanged = function () {
        if (this.onLayoutChanged)
            this.onLayoutChanged();
    };
    BrandRenderLayout.prototype.isRow = function (section) {
        return !!section && section.type === RenderSectionType.Row;
    };
    // A section has a kebab/modal only when it exposes something to configure.
    BrandRenderLayout.prototype.hasControls = function (section) {
        return this.propSchema(section.type).length > 0
            || this.usesImageProps(section)
            || this.usesBackgroundImage(section)
            || this.usesItemImages(section)
            || this.isRow(section);
    };
    BrandRenderLayout.prototype.openSectionEditor = function (section) {
        this.editingSection = section;
        this.locateSection(section);
    };
    BrandRenderLayout.prototype.closeSectionEditor = function () {
        this.editingSection = null;
    };
    // Keeps a click inside the modal panel from bubbling to the overlay (which closes it).
    BrandRenderLayout.prototype.swallow = function ($event) {
        $event.stopPropagation();
        return true;
    };
    // Clicking a section row: outline THIS instance in the preview and (when hosted) drive the host
    // selection. instanceIds aren't persisted to the preview doc, so target the section by its position
    // among same-variant instances in render order (which matches the preview's DOM order).
    BrandRenderLayout.prototype.locateSection = function (section) {
        this.selectedInstanceId = section ? section.instanceId : null;
        if (this.preview && section) {
            var variantId = this.variantIdOf(section);
            if (variantId)
                this.preview.highlightVariantInstance(variantId, this.variantInstanceIndex(section));
            else
                this.preview.highlightInstance(section.instanceId);
        }
        if (this.onSelect)
            this.onSelect(section);
    };
    // Position of `section` among all visible, block-resolving instances of the same variant, walked
    // in render order (leaf sections + Row children, matching the lobby shell). -1 when not found.
    BrandRenderLayout.prototype.variantInstanceIndex = function (section) {
        var _this = this;
        if (!this.layout || !section)
            return -1;
        var target = this.variantIdOf(section);
        var index = -1;
        var found = -1;
        var visit = function (sections) {
            var e_3, _a;
            try {
                for (var _b = __values(sections || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var s = _c.value;
                    if (s.visible === false)
                        continue;
                    if (_this.isRow(s)) {
                        visit(s.children);
                        continue;
                    }
                    if (_this.variantIdOf(s) === target) {
                        index++;
                        if (s === section)
                            found = index;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        visit(this.layout.sections);
        return found;
    };
    BrandRenderLayout.prototype.variantIdOf = function (section) {
        if (section && section.variant)
            return section.variant;
        var v = this.effectiveVariant(section);
        return v ? v.id : null;
    };
    BrandRenderLayout.prototype.findByVariant = function (sections, variantId) {
        var e_4, _a;
        try {
            for (var _b = __values(sections || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                if (this.variantIdOf(s) === variantId)
                    return s;
                if (s.children) {
                    var child = this.findByVariant(s.children, variantId);
                    if (child)
                        return child;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return null;
    };
    // Host hook: a colour group was picked on the right - select its first matching section here,
    // and focus the preview by variant (the reliable highlight the theme panel always used).
    BrandRenderLayout.prototype.selectByVariant = function (variantId) {
        if (!variantId || !this.layout)
            return;
        var found = this.findByVariant(this.layout.sections, variantId);
        if (!found)
            return;
        this.selectedInstanceId = found.instanceId;
        if (this.preview)
            this.preview.highlightVariant(variantId);
        if (this.onSelect)
            this.onSelect(found);
    };
    BrandRenderLayout.prototype.addSection = function () {
        if (!this.layout || !this.newVariantId)
            return;
        if (this.newVariantId === BrandRenderLayout_1.RowOptionId) {
            this.layout.sections.push({
                type: RenderSectionType.Row,
                instanceId: Guid.generateGuid(),
                visible: true,
                order: this.layout.sections.length,
                props: {},
                children: []
            });
            this.newVariantId = null;
            this.notifyLayoutChanged();
            return;
        }
        var variant = findRenderVariant(this.newVariantId);
        if (!variant)
            return;
        this.layout.sections.push({
            type: variant.type,
            variant: variant.id,
            instanceId: Guid.generateGuid(),
            visible: true,
            order: this.layout.sections.length,
            props: (variant.imageProps || variant.backgroundImage) ? { image: {} } : {}
        });
        this.newVariantId = null;
        this.notifyLayoutChanged();
    };
    BrandRenderLayout.prototype.addChildToRow = function (row) {
        var variantId = this.newChildVariantId[row.instanceId];
        var variant = variantId ? findRenderVariant(variantId) : null;
        if (!variant)
            return;
        row.children = row.children || [];
        row.children.push({
            type: variant.type,
            variant: variant.id,
            instanceId: Guid.generateGuid(),
            visible: true,
            order: row.children.length,
            props: (variant.imageProps || variant.backgroundImage) ? { image: {} } : {},
            columnSpan: 6
        });
        this.newChildVariantId[row.instanceId] = null;
        this.notifyLayoutChanged();
    };
    BrandRenderLayout.prototype.removeChild = function (row, index) {
        row.children.splice(index, 1);
        this.notifyLayoutChanged();
    };
    BrandRenderLayout.prototype.moveChildUp = function (row, index) {
        if (index <= 0)
            return;
        var _a = __read(row.children.splice(index, 1), 1), child = _a[0];
        row.children.splice(index - 1, 0, child);
    };
    BrandRenderLayout.prototype.moveChildDown = function (row, index) {
        if (index >= row.children.length - 1)
            return;
        var _a = __read(row.children.splice(index, 1), 1), child = _a[0];
        row.children.splice(index + 1, 0, child);
    };
    BrandRenderLayout.prototype.save = function () {
        var _this = this;
        if (!this.layout || this.saving)
            return;
        this.saving = true;
        this.layout.sections.forEach(function (s) { return (s.children || []).forEach(function (c) {
            c.columnSpan = c.columnSpan ? Number(c.columnSpan) : null;
        }); });
        this.uploadSectionImages().then(function () {
            return _this.renderThemeClientService.saveLayout({
                renderThemeId: _this.theme.renderThemeId,
                brandId: _this.resolveBrandId(),
                bundleId: _this.bundleId,
                syndicateId: _this.syndicateId,
                brandLotteryId: _this.brandLotteryId,
                pageType: _this.layout.pageType,
                name: _this.layout.name,
                sections: _this.mergeItemScope(_this.stripUnsupported(_this.layout.sections))
            });
        }).then(function (updated) {
            _this.bindTheme(updated);
            _this.saving = false;
            if (_this.preview)
                _this.preview.reload(true);
            _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("render-layout-save-success"), NotificationType.Success);
        }).catch(function () {
            _this.saving = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-layout-save-error"), NotificationType.Error);
        });
    };
    BrandRenderLayout.prototype.uploadSectionImages = function () {
        var maps = this.collectImageMaps(this.layout.sections);
        var dataUris = [];
        maps.forEach(function (m) { return Object.keys(m).forEach(function (k) {
            var v = m[k];
            if (v && v.indexOf("data:") === 0 && dataUris.indexOf(v) < 0)
                dataUris.push(v);
        }); });
        if (dataUris.length === 0)
            return Promise.resolve();
        return this.attachmentClientService.addAttachments({ dataUris: dataUris, files: null }).then(function (response) {
            maps.forEach(function (m) { return Object.keys(m).forEach(function (k) {
                var v = m[k];
                if (v && v.indexOf("data:") === 0) {
                    var match = Enumerable.from(response.attachments).firstOrDefault(function (a) { return a.dataUri === v; });
                    m[k] = match ? match.newName : "";
                }
            }); });
        });
    };
    BrandRenderLayout.prototype.collectImageMaps = function (sections) {
        var _this = this;
        var maps = [];
        (sections || []).forEach(function (s) {
            if (s.props && s.props.image)
                maps.push(s.props.image);
            if (s.children)
                _this.collectImageMaps(s.children).forEach(function (m) { return maps.push(m); });
        });
        return maps;
    };
    Object.defineProperty(BrandRenderLayout.prototype, "hasDraftChanges", {
        get: function () {
            return !!(this.theme && this.theme.hasDraftChanges);
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderLayout.prototype.publish = function () {
        var _this = this;
        if (!this.theme || this.publishing || this.saving)
            return;
        this.publishing = true;
        this.renderThemeClientService.publish(this.theme.renderThemeId, this.bundleId, this.syndicateId, this.brandLotteryId).then(function (updated) {
            _this.bindTheme(updated);
            _this.publishing = false;
            if (_this.preview)
                _this.preview.reload(true);
            _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("render-publish-success"), NotificationType.Success);
        }).catch(function () {
            _this.publishing = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-publish-error"), NotificationType.Error);
        });
    };
    BrandRenderLayout.prototype.discardDraft = function () {
        var _this = this;
        if (!this.theme || this.publishing || this.saving)
            return;
        this.publishing = true;
        this.renderThemeClientService.discardDraft(this.theme.renderThemeId, this.bundleId, this.syndicateId, this.brandLotteryId).then(function (updated) {
            _this.bindTheme(updated);
            _this.publishing = false;
            if (_this.preview)
                _this.preview.reload(true);
            _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("render-discard-success"), NotificationType.Success);
        }).catch(function () {
            _this.publishing = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-discard-error"), NotificationType.Error);
        });
    };
    var BrandRenderLayout_1;
    BrandRenderLayout.RowOptionId = "__row__";
    BrandRenderLayout.PageTypeByName = {
        lobby: RenderPageType.Lobby,
        lottery: RenderPageType.Lottery,
        cart: RenderPageType.Cart,
        results: RenderPageType.Results,
        purchases: RenderPageType.Purchases,
        bundle: RenderPageType.Bundle,
        syndicate: RenderPageType.Syndicate,
        lotteries: RenderPageType.Lotteries,
        bundles: RenderPageType.Bundles
    };
    BrandRenderLayout.PageNameByType = (_a = {},
        _a[RenderPageType.Lobby] = "lobby",
        _a[RenderPageType.Lottery] = "lottery",
        _a[RenderPageType.Cart] = "cart",
        _a[RenderPageType.Results] = "results",
        _a[RenderPageType.Purchases] = "purchases",
        _a[RenderPageType.Bundle] = "bundle",
        _a[RenderPageType.Syndicate] = "syndicate",
        _a[RenderPageType.Lotteries] = "lotteries",
        _a[RenderPageType.Bundles] = "bundles",
        _a);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], BrandRenderLayout.prototype, "embeddedPreview", void 0);
    BrandRenderLayout = BrandRenderLayout_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            BrandClientService,
            AttachmentClientService,
            RenderThemeClientService])
    ], BrandRenderLayout);
    return BrandRenderLayout;
}(ChildComponent));
export { BrandRenderLayout };
